import js_boggle_line_chart from './js-boggle-line-chart';

const line_chart_wrappers = Array.from(document.querySelectorAll('.js-bogglechart-sfx-event-listener'));

line_chart_wrappers.forEach(wrapper => {
  const line_chart = wrapper.querySelector('.js-boggle-line-chart');
  wrapper.addEventListener('scrollfx/on', () => js_boggle_line_chart(line_chart));
});

